import React from 'react';
import { Radio } from '@mui/material';
import { withStyles } from '@material-ui/core/styles';
import CheckIcon from '@mui/icons-material/Check';

const CustomRadio = withStyles({
  root: {
    padding: 6,
    color: 'rgba(208, 213, 221, 1)',
    '&$checked': {
      color: '#622FEE',
    },
    '&.Mui-disabled': {
      color: 'rgba(169, 169, 169, 1)',
    },
  },
  checked: {},
})((props) => (
  <Radio
    disableRipple
    size="small"
    icon={
      <span
        style={{
          width: 15,
          height: 15,
          borderRadius: '50%',
          border: '2px solid rgba(208, 213, 221, 1)',
        }}
      />
    }
    checkedIcon={
      <span
        style={{
          width: 15,
          height: 15,
          borderRadius: '50%',
          backgroundColor: '#622FEE',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CheckIcon style={{ fontSize: 14, color: 'white' }} />
      </span>
    }
    {...props}
  />
));

export default CustomRadio;
